<template>
  <div class="color-picker__container">
    <color-picker 
      v-model:pureColor="internalColor" 
      v-model:gradientColor="gradientColor"
      @pureColorChange="handleColorChange"
    />
  </div>
</template>

<script>
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";

export default {
  name: 'CP',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  
  data() {
    return {
      internalColor: this.modelValue,
      gradientColor: ""
    }
  },
  
  components: {
    ColorPicker
  },
  
  watch: {
    modelValue(newVal) {
      if (newVal !== this.internalColor) {
        this.internalColor = newVal;
      }
    }
  },
  
  methods: {
    handleColorChange(color) {
      this.internalColor = color;
      this.$emit('update:modelValue', color);
      this.$emit('color-change', color);
    }
  }
}
</script>

<style>
.current-color, .vc-color-wrap {
	border-radius: 0.5rem;
	border: 0.1rem solid var(--color-text);
}

</style>